import React from 'react';

import TagBox from 'devextreme-react/tag-box';

import { useSvcSelectBoxConfig } from '@/svc/hooks';

export default function SvcTagBox(props) {
  const {
    domain, entity, listOpts = {}, paginate = true, filtri = null,
    value, setValue, lookupKey = 'id',
    editorOptions = {}
  } = props;

  const svcTagBoxConfig = useSvcSelectBoxConfig({
    domain,
    entity,
    paginate,
    listOpts,
    lookupKey,
    filters: filtri
  });

  return <>
    <TagBox
      value={value}
      onValueChanged={(newValue) => setValue(newValue)}
      {
        ...{
          ...svcTagBoxConfig,
          ...editorOptions
        }
      }
    />
  </>
}
